import {openDB, idb} from 'idb';

import JavascriptHelpers from '../components/lib/Javascript/JavascriptHelpers';
import ServiceDataResponse from '../models/ServiceDataResponse';
import ServiceResponse from '../models/ServiceResponse';

const DB_NAME = "obsDb";
const DEFAULT_OBJECT_STORE = "observation";

// indexes e.g. {field: "offlineId", name: "offlineId", unique: true}
export default class LocalQueuedDbService
{
    constructor()
    {
        this.defaultObjectStore = DEFAULT_OBJECT_STORE;
        this.dbName = DB_NAME;
        this.indexes = [
            {field: "offlineId", name: "offlineId", unique: true}
        ]
        this.idb = {
            db: openDB(DB_NAME, 1,{  
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    console.log("Old Version:");
                    console.info(oldVersion);
                    switch(oldVersion)
                    {
                        case 0:
                            
                             const store = db.createObjectStore(DEFAULT_OBJECT_STORE) 
                             if (this.indexes)
                             {
                                this.indexes.forEach((i) => {
                                    store.createIndex(i.field, i.name, {unique: i.unique} )
                                })
                             }
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }


    static toLocalObservation(gcid, obs, offlineId)
    {
        let hasImages = ((obs.data.Raw.userimages) && (obs.data.Raw.userimages.length>0));
        obs.data.hasImages = hasImages;
        let hasDocs = ((obs.data.Raw.userdocs) && (obs.data.Raw.userdocs.length>0));
        obs.data.hasDocs = hasDocs;
        var localObservation = {
            "Gcid": gcid, "ObservedBy": obs.data.UnderInspection.Inspector, "ObservationLocation": obs.data.UnderInspection.Location, "ObservationDate": obs.data.UnderInspection.InspectionDate,
            "ObservationType": "QADOCKINSPECTION", "RecordedDate": obs.data.UnderInspection.InspectionDate, "SchemaId": obs.data.schema.id, "SchemaVersion" : obs.data.schema.schemaVersion,
            "ObservationHash": null, "ScoreReason": obs.score.Score.ScoreReason,
            "ScoreGrade": obs.score.Score.Grade.Weighted, "ScoreGradeInt": 0,
            "HasImages": hasImages,
            "HasDocs": hasDocs,
            "ObservationSnapshot" : JSON.stringify(obs),
            "offlineId": offlineId,
            "Offline": {id: offlineId, isUploaded: false, uploadStatus: 'pending', lastStatusUpdate: JavascriptHelpers.isoNow()}
            //offlineId: newOfflineId, observation: observation, isUploaded: false, uploadStatus: 'awaiting', lastStatusDate: moment().format()
        };
        return localObservation;
    }

    async addObservation(gcid, obs, offlineId)
    {
        try
        {
            var localObservation = LocalQueuedDbService.toLocalObservation(gcid, obs, offlineId);
            (await this.idb.db).add(DEFAULT_OBJECT_STORE, localObservation, offlineId);
            return ServiceResponse.toServiceResponse("Local Observation added", false);
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem adding Local Observation.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }

    }

    async fetchObservation(gcid, offlineId)
    {
        try
        {
            var resultData = await (await this.idb.db).get(DEFAULT_OBJECT_STORE, offlineId);
            return ServiceDataResponse.toServiceDataResponse(resultData, "Observation " + offlineId + " fetched.", false);
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching Local Observation by id " + offlineId + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async fetchObservationCount()
    {
        var resultData = await (await this.idb.db).getAllKeys(DEFAULT_OBJECT_STORE);
        return resultData.length;
    }

    async fetchAllObservations()
    {
        try
        {
            var resultData = await (await this.idb.db).getAll(DEFAULT_OBJECT_STORE);
            var result = resultData.map(offlineRec =>{
                console.log("offlineRec:");
                console.log(offlineRec);
                var res = JSON.parse(offlineRec.ObservationSnapshot);
                // add offline status fields
                res.identifiers = {id: offlineRec.Offline.id, gcid: offlineRec.Gcid, status: offlineRec.Offline.uploadStatus, statusReason: ""} ;
                return res;
            }) ;
            return ServiceDataResponse.toServiceDataResponse(result, "All Local Observations Fetched Successfully.", false)
        } 
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching All Local Observations. ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }


    async deleteObservation(offlineId)
    {
        try
        {
            var result = await (await this.idb.db).delete(DEFAULT_OBJECT_STORE, offlineId);   
            return ServiceResponse.toServiceResponse("Local observation " + offlineId + " removed successfully.", false); 
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem removing Local Observation " + offlineId + ". ", true);
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }



}



